import type { MouseEvent, ReactNode } from 'react';
import { Link as ReactRouterLink } from '@ksyos/router';
import classnames from 'classnames';
import * as styles from './Link.module.scss';

interface ILinkProps {
    children: ReactNode;
    className?: string;
    collapse?: boolean;
    isDisabled?: boolean;
    linkColor?: 'white' | 'secondary' | 'warning' | 'info' | 'success' | 'black' | 'primary' | 'muted';
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    openInNewTab?: boolean;
    to: string;
}

export function Link(props: ILinkProps) {
    const className = classnames(
        styles.link,
        props.linkColor ? styles[props.linkColor] : '',
        props.collapse ? styles.dropdownLink : ''
    );

    return (
        <ReactRouterLink
            aria-disabled={props.isDisabled}
            className={classnames(`${styles.link} `, className, props.className || '')}
            onClick={props.onClick}
            style={{ pointerEvents: props.isDisabled ? 'none' : undefined }}
            tabIndex={props.isDisabled ? -1 : undefined}
            target={props.openInNewTab ? '_blank' : undefined}
            to={props.to}
        >
            {props.children}
        </ReactRouterLink>
    );
}
